/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DayOff from './day-off';
import DayOffDetail from './day-off-detail';
import DayOffUpdate from './day-off-update';
import DayOffDeleteDialog from './day-off-delete-dialog';

const DayOffRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DayOff />} />
    <Route path="new" element={<DayOffUpdate />} />
    <Route path=":id">
      <Route index element={<DayOffDetail />} />
      <Route path="edit" element={<DayOffUpdate />} />
      <Route path="delete" element={<DayOffDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DayOffRoutes;
